import { configuredJingle } from "../app/media";
import { safeHttpUrl } from "../app/safe-url";

function setButtonState(button, playing) {
  const label = button.querySelector(".jingle-control__label");
  button.setAttribute("aria-pressed", String(playing));
  button.setAttribute(
    "aria-label",
    playing ? "Pausar música de Navidad" : "Reproducir música de Navidad",
  );
  button.dataset.jingleState = playing ? "playing" : "paused";
  if (label) label.textContent = playing ? "Pausar Jingle" : "Activar Jingle";
}

export function initJingle(config, activePhase, coordinator) {
  const button = document.querySelector("[data-jingle-control]");
  if (!button || !configuredJingle(config, activePhase)) return null;

  const src = safeHttpUrl(config.src);
  if (!src) return null;

  const audio = document.createElement("audio");
  audio.src = src;
  audio.preload = "none";
  audio.loop = config.loop === true;

  let playRequest = 0;
  const controller = {
    stop() {
      playRequest += 1;
      audio.pause();
      setButtonState(button, false);
    },
  };

  coordinator.register(controller);
  setButtonState(button, false);
  button.hidden = false;

  const pause = () => {
    playRequest += 1;
    audio.pause();
    coordinator.release(controller);
    setButtonState(button, false);
  };

  const play = async () => {
    const request = ++playRequest;
    coordinator.activate(controller);

    try {
      await audio.play();
      if (request !== playRequest) return;
      setButtonState(button, true);
    } catch {
      if (request !== playRequest) return;
      coordinator.release(controller);
      setButtonState(button, false);
    }
  };

  button.addEventListener("click", () => {
    if (audio.paused) play();
    else pause();
  });
  audio.addEventListener("play", () => setButtonState(button, true));
  audio.addEventListener("pause", () => setButtonState(button, false));
  audio.addEventListener("ended", () => {
    coordinator.release(controller);
    setButtonState(button, false);
  });
  audio.addEventListener("error", () => {
    coordinator.release(controller);
    setButtonState(button, false);
  });

  return { audio, button, controller };
}
